import { toast } from "react-toastify"
import { api } from "../../Lib/constants"
import { ADD_AWARD, ADD_AWARD_FAILED, ADD_AWARD_SUCCESS, AWARD, AWARD_FAILED, AWARD_SUCCESS, UPDATE_AWARD, UPDATE_AWARD_FAILED, UPDATE_AWARD_SUCCESS } from "./actionTypes"
import { getAuthHeader } from "../../Lib/utils"


export const getAwards = () => async (dispatch) => {
  dispatch({
    type: AWARD,
  });
  try {
    let response = await api(`award/awardList`, "get", {}, getAuthHeader());
    dispatch({
      type: AWARD_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching Award list error ====>", error);
    return dispatch({
      type: AWARD_FAILED,
      payload: error?.message,
    });
  }
};

export const addAward = (data) => async dispatch => {
  dispatch({
    type: ADD_AWARD
  })
  try {
    let response = await api(`award/add`, 'post', data, getAuthHeader())
    console.log('add award data', response);
    toast.success("Added Successfully");
    dispatch({
      type: ADD_AWARD_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while Adding award error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: ADD_AWARD_FAILED,
      payload: error?.message
    })
  }
}

export const updateAward = (id, data) => async dispatch => {
  dispatch({
    type: UPDATE_AWARD
  })
  try {
    let response = await api(`award/update/${id}`, 'put', data, getAuthHeader())
    console.log('update award data', response);
    toast.success("Updated Successfully");
    dispatch({
      type: UPDATE_AWARD_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while updating award error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: UPDATE_AWARD_FAILED,
      payload: error?.message
    })
  }
}